import { Tool } from '@/util/index'

const ATTRIBUTE_ACCESS_TOKEN = 'Access-Token'
const LOAN_ID = 'LoanId'
class Cache {
  setAccessToken (token) {
    window.localStorage.setItem(ATTRIBUTE_ACCESS_TOKEN, token)
  }

  getAccessToken () {
    return window.localStorage.getItem(ATTRIBUTE_ACCESS_TOKEN)
  }

  removeAccessToken () {
    window.localStorage.removeItem(ATTRIBUTE_ACCESS_TOKEN)
  }

  setLoanId (id) {
    window.localStorage.setItem(LOAN_ID, id)
  }

  getLoanId () {
    return window.localStorage.getItem(LOAN_ID)
  }

  removeLoanId () {
    window.localStorage.removeItem(LOAN_ID)
  }

  setSessionLoanId (id) {
    window.sessionStorage.setItem(LOAN_ID, id)
  }

  getSessionLoanId () {
    return window.sessionStorage.getItem(LOAN_ID)
  }

  removeSessionLoanId () {
    window.sessionStorage.removeItem(LOAN_ID)
  }

  // clear cached sign-in data after sign-out
  clearSignInData () {
    localStorage.removeItem(ATTRIBUTE_ACCESS_TOKEN)
  }

  setItem (key, value) {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value)
    }
  }

  getItem (key) {
    let itemValue = localStorage.getItem(key)

    const tool = new Tool()

    if (tool.isNotEmpty(itemValue)) {
      if (itemValue.isJson()) {
        itemValue = itemValue.toJson()
      }
    }

    return itemValue
  }

  removeItem (key) {
    localStorage.removeItem(key)
  }

  clear () {
    localStorage.clear()
  }
}

export { Cache }
